// User roles constants
export const USER_ROLES = {
  ADMIN: 'Admin',
  MANAGER: 'Manager', 
  USER: 'User'
} as const;

// Type for user roles
export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

// Helper functions for role checking
export const isAdmin = (role: UserRole): boolean => role === USER_ROLES.ADMIN;
export const isManager = (role: UserRole): boolean => role === USER_ROLES.MANAGER;
export const isUser = (role: UserRole): boolean => role === USER_ROLES.USER;

// Check if user has manager access (Admin or Manager)
export const hasManagerAccess = (role: UserRole): boolean => 
  role === USER_ROLES.ADMIN || role === USER_ROLES.MANAGER;

// Array of all roles for validation
export const ALL_ROLES = Object.values(USER_ROLES);

// Validate if string is a valid role
export const isValidRole = (role: string): role is UserRole => 
  ALL_ROLES.includes(role as UserRole);

// Role display names for UI
export const ROLE_DISPLAY_NAMES = {
  [USER_ROLES.ADMIN]: 'Admin',
  [USER_ROLES.MANAGER]: 'Manager',
  [USER_ROLES.USER]: 'User'
} as const;